import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as constants from "../utils/constants"
import Item from './Item'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles({
    canvas:{
      padding:'20px',
      width:'100%',
      overflow:'auto'
    },
    borderBox:{
      padding:'20px',
      boxShadow:'1.5px 1.5px 1.5px 1.5px #888888',
      overflow:'auto'
    },
    docTextField: {
      border: 'none',
      borderBottom: '1px dotted gray',
      marginTop: '5px',
      marginBottom: '5px',
      fontStyle: 'italic',
      lineHeight: '2',
      width:'100%'
    },
    dialog:{
        width:'800px',
        maxWidth:'800px'
    },
    documentTable: {
      borderCollapse: 'collapse',
      margin: '20px auto',
      width:'90%',
      height:'90%'
    },
    tableCell: {
      borderColor: 'rgb(51, 51, 51)',
      paddingTop:'0px',
      height:'50px'
    },
    addLabelButton: {
        display: 'inline-block',
        marginBottom:'20px',
        fontSize:'10px',
        borderRadius:'16px'
      },
    paragraphBox: {
        width: '100%', 
        padding: '10px 0px', 
        resize: 'none', 
        fontSize: '12px', 
        fontWeight: 400, 
        marginBottom: '10px', 
        borderTop: '0px', 
        borderLeft: '0px', 
        borderRight: '0px', 
        height: '30px', 
        overflowY: 'auto'
    },
    fieldContainer: {
        fontSize: '12px', 
        margin: 0, 
        lineHeight: '14px',
        width: '200px' 
    },
    lineSpace: {
        fontSize: '6px', 
        margin: 0, 
        lineHeight: '6px' 
    },
    label: {
        fontSize: '12px', 
        margin: 0,
        lign:'left', 
        lineHeight: '14px', 
        fontWeight: 'bold'
    },
    tableTitle: {
      fontSize: '24px',
      fontWeight: 'bold',
      textAlign: 'center', 
      width: '75%'
    },
    lineSpace: {
        fontSize: '6px', 
        margin: 0, 
        lineHeight: '6px' 
    },
    cellBorder: {
        padding: '5px', 
        border: '1px solid rgb(51, 51, 51)'
    }

  });

export default function PreviewDialog(props) {
  const classes = useStyles();
  const { onClose, json,open,title } = props;
  const [scroll, setScroll] = React.useState('paper');

  const handleClose = () => {
    onClose();
  };


  const Row = (props)=>{
    return(
        <tr>
            <Col cols={props.cols} id={props.id} key ={props.id} />
        </tr> 

    )
}


const Col = (props)=>{
    if(props.cols){
        return(
            Object.keys(props.cols).map(e=>(
         
              <td colSpan={json[props.id][e]['span'][1]} rowSpan={json[props.id][e]['span'][0]} valign="top" height={20} className={classes.cellBorder}>
                  {!json[props.id][e]['type']?
                    <Condition row={props.id} col={e}  rowSpan={json[props.id][e]['span'][0]} colSpan={json[props.id][e]['span'][1]} />:
                    <>
                        <Item row={props.id} labels = {json[props.id][e]['fields']['labels']} textFields={{'rows':json[props.id][e]['fields']['text'][0],'columns':json[props.id][e]['fields']['text'][1]}}  col={e} type={'preview'}/>
                        <div style={{textAlign:'center'}}>
                        <Button variant="contained" className={classes.addLabelButton}> Add Item </Button>
                        </div>
                    </>
                  }
              </td>
            ))
      
        )
    }
}

const Condition = (props)=>{
    
    var fieldsArray = json[props.row][props.col]['fields']
    var result = [];
    if(!fieldsArray) return ;
    for(let i=0;i<fieldsArray.length;i++){
        result.push(element(fieldsArray[i]['type'],fieldsArray[i]['id'],props.row,props.col,props.rowSpan,props.colSpan))
    }
    
    return result;
}

function element(componentType,id,row,col,rowSpan,colSpan){
    var value = [];
    value = json[row][col]['fields'].filter(f=>(f['id']===id))
    if(componentType === constants.LABEL){
        return (
            <>
                <p className={classes.label}>{value[0]===undefined?"":value[0]['name']}</p>
                <p className={classes.lineSpace}>&nbsp;</p>
            
            </>
        )
    }
    else if(componentType === constants.PARAGRAPH){
        return(
            <>
                <textarea value= {value[0]===undefined?"":value[0]['name']} className={classes.docTextField}  rows={4} data-autosize-on="true" disabled />
            </>
        )
    }
    else if(componentType === constants.DROPDOWN){
        return(
            <>
                <p className={classes.fieldContainer}>
                    <select value= {value[0]===undefined?"":value[0]['name']} className={classes.docTextField} disabled/>
                </p>
                
            </>
        )
    }
    else if(componentType=== constants.CHECKBOX){
        return(
            <>
                <p className={classes.fieldContainer}>
                    <input value='default1' type="checkbox" id="default1" name="default" checked={value[0]===undefined?false:(value[0]['name'].includes('default1')?true:false)} disabled />
                    <label for="default1"> Default 1</label>

                    <input type="checkbox" id="default2" name="default" value="default2" checked={value[0]===undefined?false:(value[0]['name'].includes('default2')?true:false)} disabled />
                    <label for="default2"> Default 2</label>
                </p>
                
            </>
        )
    }
    else if(componentType === constants.RADIOBOX){
        return(
            <>
                <p className={classes.fieldContainer}>
                    <input value='default1' type="radio" id="default1" name="default" checked={value[0]===undefined?false:(value[0]['name']==='default1'?true:false)} disabled/>
                    <label for="default1"> Default 1</label>

                    <input type="radio" id="default2" name="default" value="default2" checked={value[0]===undefined?false:(value[0]['name']==='default2'?true:false)} disabled/>
                    <label for="default2"> Default 2</label>
                </p>

                
            </>
        )
    }
    else{
        return (
            <>
                <p className={classes.fieldContainer}>
                    <input value= {value[0]===undefined?"":value[0]['name']} className={classes.docTextField} autoComplete="off" type="text"  name="123" disabled />
                </p>
            </>
        )
    }
    
}

  return (
    <Dialog fullscreen={true} maxWidth='md' onClose={handleClose} scroll={scroll}
    aria-labelledby="scroll-dialog-title"
    aria-describedby="scroll-dialog-description" open={open}>
      <DialogTitle id="scroll-dialog-title">Preview</DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
      <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
      <div className={classes.canvas}>
        <div className={classes.borderBox}>
           <div >
            <table cellSpacing={0} cellPadding={0} className={classes.documentTable} >
                <tbody>
                <tr>
                    <td colSpan={6} align="center" className={classes.tableCell}>
                    <p className={classes.tableTitle}>{title}</p><p className={classes.lineSpace}>&nbsp;</p>
                    </td>
                </tr>
                {Object.keys(json).map(e =>(
                    <Row cols={json[e]} id={e} key={e} />
            ))}
            </tbody>
            </table>
        </div>
        </div>
        </div>
        </DialogContentText>
        </DialogContent>
      
    </Dialog>
  );
}